import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';

import { routes } from './app.routes';
import { jwtInterceptor } from './interceptors/jwt.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      // Reset scroll to the top on forward navigation (and restore the prior
      // position on back/forward), so opening a page from a scrolled-down list
      // — e.g. the dashboard "Ready to Assign" tile → /batches/new — lands at
      // the top instead of inheriting the previous page's scroll offset.
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })
    ),
    provideHttpClient(
      withInterceptors([jwtInterceptor])
    ),
    provideAnimations(),
    provideToastr({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      progressBar: true,
      progressAnimation: 'increasing',
      enableHtml: true,
      closeButton: true,
      tapToDismiss: true,
      maxOpened: 5,
      autoDismiss: true,
      newestOnTop: true,
      iconClasses: {
        error: 'toast-error',
        info: 'toast-info', 
        success: 'toast-success',
        warning: 'toast-warning'
      },
      titleClass: 'toast-title',
      messageClass: 'toast-message',
      toastClass: 'ngx-toastr custom-toast'
    })
  ]
};
